/**
 * Dress Code types — frontend
 * Mirrors backend/src/models/DressCode.ts
 */

export type Gender = 'male' | 'female' | 'unisex';
export type AgeCategory = 'toddler' | 'children' | 'teenager' | 'adult' | 'senior';

export const GENDERS: Gender[] = ['male', 'female', 'unisex'];
export const AGE_CATEGORIES: AgeCategory[] = ['toddler', 'children', 'teenager', 'adult', 'senior'];

export const GENDER_LABELS: Record<Gender, string> = {
  male: 'Male',
  female: 'Female',
  unisex: 'Non-Binary / Unisex',
};

export const AGE_CATEGORY_LABELS: Record<AgeCategory, string> = {
  toddler: 'Toddlers (0–4)',
  children: 'Children (5–12)',
  teenager: 'Teenagers (13–17)',
  adult: 'Adults (18–59)',
  senior: 'Senior Citizens (60+)',
};

export interface DressCodeTemplate {
  id: number;
  name: string;
  gender: Gender;
  age_category: AgeCategory;
  description: string;
  avoid: string | null;
  is_system: boolean;
  created_by: number | null;
  tag_value_ids: number[];
  tag_values: string[];
  tag_categories: string[];
  created_at: string;
  updated_at: string;
}

export interface DressCodeTemplateGroup {
  name: string;
  match_count: number;
  total_template_tags: number;
  match_percentage: number;
  templates: DressCodeTemplate[];
}

export interface EventDressCode {
  id: number;
  event_id: number;
  celebration_id: number;
  gender: Gender;
  age_category: AgeCategory;
  description: string;
  avoid: string | null;
  template_id: number | null;
  created_by: number;
  created_at: string;
  updated_at: string;
  deleted_at: string | null;
}

export interface CreateDressCodeDto {
  celebration_id: number;
  gender: Gender;
  age_category: AgeCategory;
  description: string;
  avoid?: string;
  template_id?: number;
}

export interface UpdateDressCodeDto {
  celebration_id: number;
  description?: string;
  avoid?: string;
}

export interface BulkCreateDressCodeDto {
  celebration_id: number;
  template_name: string;
}

/**
 * A keyed grid for easy lookup: `${gender}__${age_category}` → EventDressCode
 */
export type DressCodeGrid = Record<string, EventDressCode | undefined>;

export function dressCodeGridKey(gender: Gender, ageCategory: AgeCategory): string {
  return `${gender}__${ageCategory}`;
}
